<!-- Overrides @basecom-gmbh/pond/components/Layout/Navigation/Navigation.vue -->
<script setup lang="ts">
const { languageIdChain } = useSessionContext();
const navigationStore = useNavigationStore();
const { mainNavigationElements } = storeToRefs(navigationStore);
await navigationStore.loadMainNavigation(5);

watch(
    languageIdChain,
    async () => {
        await navigationStore.loadMainNavigation(5);
    },
    { immediate: true },
);
</script>

<template>
    <div class="relative hidden grow md:block">
        <div class="flex flex-wrap gap-8 overflow-x-auto">
            <NavigationMainItem
                v-for="navigationElement in mainNavigationElements"
                :key="`nav-item-${navigationElement.id}`"
                :navigation-element="navigationElement"
            />
        </div>
    </div>
</template>
